import stripQueryParams from '../../common/utils/stripQueryParams';

export default function maybeByteRanged(
  url: string,
  headers: Map<string, string>
): string {
  const oid = stripQueryParams(url);
  const rangeReq = headers.get('range') || headers.get('Range');
  return rangeReq ? `${oid}|${rangeReq}` : oid;
}
